import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const WindowsLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            height="56.693px"
            version="1.1"
            viewBox="0 0 56.693 56.693"
            width="56.693px"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.446,47.569c-2.485-1.655-5.119-3.122-8.917-3.122c-2.304,0-5.046,0.547-8.438,1.915l4.49-15.565 c0.512-0.209,1.011-0.398,1.494-0.574c1.638-0.576,3.97-1.23,6.529-1.443c0.292-0.025,0.58-0.034,0.87-0.034 c2.553,0,4.883,0.892,6.555,1.749c0.717,0.386,1.393,0.805,2.064,1.223C25.501,33.752,22.368,44.444,21.446,47.569"
                fill="currentColor"
            />
            <path
                d="M33.466,52.451c-3.93,0-9.17-3.229-9.164-3.226l4.477-15.542c1.363,1.088,4.518,3.156,9.707,3.156 c2.383,0,5.203-0.44,8.477-1.613l-4.314,15.08C38.927,51.842,35.954,52.451,33.466,52.451"
                fill="currentColor"
            />
            <path
                d="M31.505,12.437v0.011c-0.922,3.157-3.652,12.514-4.57,15.629 M26.935,28.077 c-2.4-1.592-4.98-3.046-8.621-3.083c-0.04,0-0.079,0-0.121,0c-2.348,0-5.141,0.622-8.584,2.026l4.423-15.53 c3.352-1.368,6.078-1.918,8.354-1.962c0.016,0,0.033,0,0.051,0c1.338,0,2.545,0.159,3.613,0.412 c2.238,0.571,5.455,2.497,5.455,2.497"
                fill="currentColor"
            />
            <path
                d="M39.499,33.2c-3.912,0-7.158-1.349-9.652-3.017c-0.016-0.01-0.035-0.021-0.047-0.034l4.535-15.697 c1.436,1.116,4.678,3.208,9.596,3.208c2.475,0,5.367-0.529,8.672-1.972L48.128,31.1c-0.012,0.004-0.021,0.01-0.027,0.01 c0,0.006,0,0.016,0,0.021C44.96,32.611,42.085,33.2,39.499,33.2"
                fill="currentColor"
            />
        </svg>
    );
};
